import { render } from "./PageNotFound.vue?vue&type=template&id=b327170c"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=b327170c&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__